module.exports = __webpack_public_path__ + "img/project-banner.3a2509a1.png";